import { z } from 'zod'
import { noteNameSchema } from './note.js'

const modes = ['ionian', 'dorian', 'phrygian', 'lydian', 'mixolydian', 'aeolian', 'locrian'] as const

export const scaleNames = ['major', 'minor', 'majorpentatonic', 'minorpentatonic', 'harmonicminor', ...modes] as const
const scaleTypeSchema = z.enum(scaleNames)

export const modeSchema = z.enum(modes)
export const scaleSchema = z.object({
  root: noteNameSchema,
  type: scaleTypeSchema.optional(),
})

export type Scale = z.infer<typeof scaleSchema>

export type ModeType = z.infer<typeof modeSchema>
export type ScaleType = z.infer<typeof scaleTypeSchema>
